<template>
  <base-list-layout :title="'Affiliate Overall'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="3.2rem">
        <el-form-item label="Affiliate ID">
          <group-select
            v-model="filter.affiliateIds"
            :data-source="affiliatesGroupList"
            multiple
            :loading="affiliateLoading"
            clearable
            reserve-keyword
            filterable
            placeholder="请选择"
          >
          </group-select>
        </el-form-item>
        <el-form-item label="Affiliate status">
          <el-select v-model="filter.status" placeholder="active">
            <el-option
              v-for="item in AffiliateConstants.statusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Affiliate trafficType">
          <el-select v-model="filter.trafficType" placeholder="请选择">
            <el-option
              v-for="item in payoutTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Affiliate name">
          <el-input v-model="filter.company" placeholder="your searching aff regex here" />
        </el-form-item>
        <el-form-item label="Company Platform">
          <el-input v-model="filter.companyPlatform" />
        </el-form-item>
        <el-form-item label="Company Entity">
          <el-input v-model="filter.companyEntity" />
        </el-form-item>
        <el-form-item label="AM Name">
          <el-input v-model="filter.amName" />
        </el-form-item>
        <el-form-item label="BD Name">
          <el-input v-model="filter.bdName" />
        </el-form-item>
        <el-form-item label="Email">
          <el-input v-model="filter.email" />
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <div class="filter-action">
        <el-button type="primary" @click="checkList(1)">Search</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addClick">Create</el-button>
      </div>
    </template>
    <template #table>
      <el-table v-loading="loading" :data="dataList" highlight-current-row>
        <el-table-column label="Id" align="center" fixed min-width="120">
          <template slot-scope="scope">
            <span @click="detailClick(scope.row)" class="cor337ab7">
              {{ scope.row.id }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Affiliate Name" prop="company" align="center" min-width="130" fixed>
          <template slot-scope="scope">
            <span @click="detailClick(scope.row)" class="cor337ab7">{{ scope.row.company }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Company Platform"
          prop="companyPlatform"
          show-overflow-tooltip
          align="center"
          min-width="190"
        >
          <template #default="scope">
            <el-popover trigger="click">
              <el-descriptions size="mini" :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Name
                  </template>
                  {{ scope.row.bankName }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Address
                  </template>
                  {{ scope.row.bankAddress }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Account Number
                  </template>
                  {{ scope.row.bankAccountNumber }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Bank Account Name
                  </template>
                  {{ scope.row.bankAccountName }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Swift Code
                  </template>
                  {{ scope.row.swiftCode }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Branch Code
                  </template>
                  {{ scope.row.branchCode }}
                </el-descriptions-item>
              </el-descriptions>
              <el-button type="text" slot="reference">{{ scope.row.companyPlatform }}</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="Company Entity"
          prop="companyEntity"
          align="center"
          show-overflow-tooltip
          width="180"
        />
        <el-table-column label="Invoice information" align="center" min-width="190">
          <template #default="scope">
            <el-popover trigger="click">
              <el-descriptions :column="1" border>
                <el-descriptions-item>
                  <template slot="label">
                    Company Name En
                  </template>
                  {{ scope.row.companyNameEn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Address
                  </template>
                  {{ scope.row.companyAddress }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Address En
                  </template>
                  {{ scope.row.companyAddressEn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Postal Code
                  </template>
                  {{ scope.row.companyPhone }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Company Phone
                  </template>
                  {{ scope.row.companyPhone }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Brn
                  </template>
                  {{ scope.row.brn }}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    Tin
                  </template>
                  {{ scope.row.tin }}
                </el-descriptions-item>
              </el-descriptions>
              <el-button type="text" slot="reference"
                >{{
                  scope.row.companyNameEn === undefined
                    ? scope.row.companyEntity
                    : scope.row.companyNameEn
                }}
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="Email"
          prop="email"
          align="center"
          show-overflow-tooltip
          width="180"
        />
        <el-table-column label="AM Name" prop="amName" align="center" width="120px" />
        <el-table-column label="BD Name" prop="bdName" align="center" width="120px" />
        <el-table-column label="Affiliate Status" prop="status" align="center" width="120px" />
        <el-table-column
          label="Postback Url"
          prop="postbackUrl"
          width="120px"
          show-overflow-tooltip
        />
        <el-table-column
          label="Event Pb Url"
          prop="eventPbUrl"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          label="Reject Pb Url"
          prop="rejectPbUrl"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          label="Dynamic Pb"
          prop="isDynamicPb"
          min-width="120"
          show-overflow-tooltip
        >
          <template v-slot="{ row }">
            {{ row.isDynamicPb === 1 ? 'yes' : row.isDynamicPb === 0 ? 'no' : 'unknown' }}
          </template>
        </el-table-column>
        <el-table-column
          label="Dynamic Pb Params"
          prop="dynamicPbParams"
          min-width="165"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="Description"
          prop="description"
          align="center"
          min-width="100"
          show-overflow-tooltip
        />
        <el-table-column
          label="Token Code"
          prop="code"
          align="center"
          min-width="300"
          show-overflow-tooltip
        />
        <el-table-column label="Adjusted" prop="adjusted" align="center" min-width="100" />
        <el-table-column label="Delay time" prop="outHourAdjust" align="center" min-width="100" />
        <el-table-column
          label="ClickLimited"
          prop="crBlackLimited"
          align="center"
          min-width="110"
        />
        <el-table-column
          label="BlackByCrClicks"
          prop="crBlackClicks"
          align="center"
          min-width="140"
        />
        <el-table-column
          label="Track Domain"
          prop="trackDomain"
          align="center"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          label="operator"
          prop="createBy"
          align="center"
          min-width="100"
          show-overflow-tooltip
        />
        <el-table-column
          label="operation time"
          prop="createTime"
          align="center"
          min-width="130"
          show-overflow-tooltip
        />
        <el-table-column label="Option" align="center" min-width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="updateAffiliateClick(scope.row)">Update </el-button>
            <el-button @click="openAffUser(scope.row)">UserAff</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="pageSize"
        :currentPage="currentPage"
      ></pagination>
    </template>

    <template #dialog>
      <AffiliateBaseForm
        :dialog-visible.sync="dialogVisible"
        :dialog-type="dialogType"
        :update-data="updateData"
        @refresh-list="checkList"
      />
      <el-dialog
        :visible.sync="userDialogVisible"
        :close-on-click-modal="false"
        :append-to-body="true"
      >
        <el-transfer
          filterable
          :titles="['Authorizable', 'Authorised']"
          v-model="affUserList"
          :data="allUser"
        ></el-transfer>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="authAffUser()">确 定</el-button>
        </span>
      </el-dialog>
    </template>
  </base-list-layout>
</template>
<script>
  import { getAffiliateList, updateAffUser, getAffUserList } from 'api/affiliate/overall';
  import Pagination from '@/components/pagination';
  import { myMixin } from '@/mixins/mixins.js';
  import { getUserList } from 'api/user';
  import { mapState, mapActions } from 'vuex';
  import GroupSelect from '@/components/GroupSelect';
  import AffiliateBaseForm from '@/views/affiliate/forms/AffiliateBaseForm.vue';
  import { AffiliateConstants } from '@/assets/js/constants';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { getCompanyInfoList } from 'api/common/companyInfo';

  let clickTimer = null;

  const defaultAffiliate = {
    company: '',
    companyPlatform: '',
    description: '',
    level: '',
    trafficType: '',
    postbackUrl: '',
    eventPbUrl: '',
    rejectPbUrl: '',
    trackDomain: '',
    adjusted: '',
    isDynamicPb: 0,
    dynamicPbParams: '',
    outHourAdjust: '',
    status: '',
    crBlackLimited: 'CLOSE',
    crBlackClicks: '',
    bfiId: '',
    bindAccountId: '',
    amId: '',
    amName: '',
    bdId: '',
    bdName: '',
    bfbId: null,
  };
  export default {
    mixins: [myMixin],
    components: {
      BaseListLayout,
      AffiliateBaseForm,
      Pagination,
      GroupSelect,
    },
    data() {
      return {
        loading: false,
        pageSize: 10,
        currentPage: 1,
        total: null,
        dialogVisible: false,
        dialogType: 'new',
        updateData: {},
        affiliate: Object.assign({}, defaultAffiliate),

        filter: {
          affiliateId: null,
          status: 'active',
          payoutType: null,
          company: null,
          companyEntity: null,
          companyPlatform: null,
          amName: null,
          amId: null,
          bdId: null,
          bdName: null,
          email: null,
        },
        status: [
          {
            label: 'ACTIVE',
            value: 'ACTIVE',
          },
          {
            label: 'PENDING',
            value: 'PENDING',
          },
        ],
        trafficType: [
          {
            label: 'CPI',
            value: 'CPI',
          },
          {
            label: 'CPA',
            value: 'CPA',
          },
          {
            label: 'CPL',
            value: 'CPL',
          },
        ],
        payoutTypeOptions: [
          {
            label: 'ALL',
            value: null,
          },
          {
            label: 'CPI',
            value: 'CPI',
          },
          {
            label: 'CPA',
            value: 'CPA',
          },
        ],
        dataList: [],
        userDialogVisible: false,
        affUserList: [],
        allUser: [],
        affiliateId: '',
      };
    },
    computed: {
      AffiliateConstants() {
        return AffiliateConstants;
      },
      ...mapState('affiliate', {
        affiliatesGroupList: (state) => state.affiliatesGroupList,
        affiliateLoading: (state) => state.affiliateLoading,
      }),
      rules() {
        const crBlackClicksRule =
          this.affiliate.crBlackLimited === 'OPEN'
            ? [
                {
                  required: true,
                  message: 'please write BlackByCrClicks',
                  trigger: ['change', 'blur'],
                },
              ]
            : [];
        return {
          affiliateName: [
            {
              required: true,
              message: 'please write name',
              trigger: 'blur',
            },
          ],
          trafficType: [
            {
              required: true,
              message: 'please select traffic type',
              trigger: 'blur',
            },
          ],
          adjusted: [
            {
              required: true,
              message: 'please select adjusted',
              trigger: 'blur',
            },
          ],
          isDynamicPb: [
            {
              required: true,
              message: 'please select dynamic pb',
              trigger: 'blur',
            },
          ],
          dynamicPbParams: [
            {
              validator: (rule, value, callback) => {
                const firstChar = value.trim().charAt(0);
                if (firstChar !== '&' && firstChar !== '?') {
                  callback(new Error('Please write the first character as either & or ?'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ],
          description: [
            {
              required: true,
              message: 'please write description',
              trigger: 'blur',
            },
          ],
          status: [
            {
              required: true,
              message: 'please select status',
              trigger: 'blur',
            },
          ],
          crBlackClicks: crBlackClicksRule,
          bindAccountId: {
            required: true,
            message: 'please select bindAccountId',
            trigger: 'blur',
          },
        };
      },
    },
    mounted() {
      this.getAffiliateList();
      this.checkList();
      this.getCompanyInfo();
    },
    methods: {
      ...mapActions('affiliate', ['getAffiliateList']),
      getCompanyInfo() {
        getCompanyInfoList({}).then((res) => {
          if (res) {
            const result = res.result;
            this.companyInfoList = result.dataList;
          }
        });
      },
      checkList(page) {
        this.loading = true;
        if (page) {
          this.currentPage = page;
        }
        let param = {
          ...this.filter,
          page: this.currentPage,
          pageSize: this.pageSize,
        };
        if (param.affiliateIds) {
          param.affiliateIds = param.affiliateIds.join(',');
        }
        getAffiliateList(param).then((response) => {
          if (response.code === 200) {
            this.loading = false;
            this.dataList = response.result.dataList;
            this.total = response.total;
          } else {
            this.loading = false;
            this.$message.error(response.message);
          }
        });
      },
      addClick() {
        this.affiliate = Object.assign({}, defaultAffiliate);
        delete this.affiliate.status;
        this.dialogType = 'new';
        this.dialogVisible = true;
        this.updateData = {
          bfiId: null,
          bfbId: null,
        };
      },
      handleSizeChange(size) {
        this.pageSize = size;
        this.handleCurrentChange(1);
      },
      handleCurrentChange(currentPage) {
        this.currentPage = currentPage;
        this.checkList();
      },
      updateAffiliateClick(row) {
        let data = row;
        data.affiliateName = row.company;
        this.affiliate = Object.assign({}, defaultAffiliate, row);
        this.dialogType = 'edit';
        this.dialogVisible = true;
        this.updateData = this.affiliate;
        if (this.updateData.bfbId === undefined) {
          this.updateData.bfbId = null;
        }
        if (this.updateData.bfiId === undefined) {
          this.updateData.bfiId = null;
        }
      },
      detailClick(row) {
        if (clickTimer) {
          window.clearTimeout(clickTimer);
          clickTimer = null;
        }
        clickTimer = window.setTimeout(() => {
          this.$nextTick(() => {
            console.log(row, 'row');
            const { href } = this.$router.resolve({
              path: '/affiliate/detail',
              query: {
                affiliateId: row.id,
                affiliateName: row.company,
                status: row.status,
              },
            });
            window.open(href, '_blank');
          });
        }, 300);
      },
      async getAllUser() {
        const { code, result = [] } = await getUserList();
        if (code) {
          this.allUser = result.map((item) => ({
            key: item.id,
            label: item.uname,
            title: item.uname,
          }));
        }
      },
      async getAffUsers(affiliateId) {
        const { code, result = [] } = await getAffUserList(affiliateId);
        if (code === 200) {
          this.affUserList = result.map((item) => item.id);
        } else {
          this.$message.error('Failed to get authorized list');
        }
      },
      openAffUser(row) {
        this.affiliateId = row.id;
        this.getAllUser();
        this.getAffUsers(row.id);
        this.userDialogVisible = true;
      },
      async authAffUser() {
        const params = {
          affiliateId: this.affiliateId,
          accountList: this.affUserList,
        };
        const { code, message } = await updateAffUser(params);
        if (code === 200) {
          this.$message.success({
            message: 'Update Success',
            type: 'success',
          });
          this.userDialogVisible = false;
        } else {
          this.$message.error('Update Error:' + message);
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .cor337ab7 {
    color: #337ab7;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  ::v-deep .el-transfer {
    display: flex;
    justify-content: center;
    align-items: center;

    .el-transfer-panel {
      width: 288px !important;
    }
  }
</style>
